import React from 'react';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import './style.scss';

const StepsBar = ({ t, activeStep , steps }) => {

  const progress = ((activeStep - 1) / (steps.length - 1)) * 100;

  return (
    <div className="StepsBarContainer">
      <div className="StepsContent">
        {steps.map((step) => (
          <div
            key={step.number}
            className={`StepItem ${activeStep === step.number ? 'active' : 'hidden-mobile'}`}
          >
            <div className={`StepNumber ${activeStep === step.number ? 'active' : ''}`}>
              {step.number}
            </div>
            <div className="StepContent">
              <h3 className="StepTitle">{step.title}</h3>
              {activeStep === step.number && (
                <p className="StepDescription">{step.descriptions}</p>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {/* Desktop Progress Bar */}
      <div className="DesktopProgressBar">
        <div className="ProgressText">
          <span>{t('TotalProgress')}</span>
          <div>({Math.round(progress)}%)</div>
        </div>
        <div className="ProgressTrack">
          <div className="ProgressFill" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(StepsBar));